import type { InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import { IconSearch } from "./icons";

type Props = {
	value: string;
	onChange: (value: string) => void;
	onSubmit?: () => void;
	placeholder?: string;
	disabled?: boolean;
	searching?: boolean;
	className?: string;
	inputProps?: Omit<
		InputHTMLAttributes<HTMLInputElement>,
		"value" | "onChange" | "className" | "disabled" | "placeholder"
	>;
};

export function SearchField({
	value,
	onChange,
	onSubmit,
	placeholder = "Suchen…",
	disabled,
	searching,
	className,
	inputProps,
}: Props) {
	return (
		<form
			className={cn(
				"flex h-9 items-center gap-2 rounded-[var(--radius-control)] bg-surface px-2.5",
				"shadow-[var(--shadow-float)] ring-1 ring-[var(--ring-hairline)]",
				"focus-within:ring-2 focus-within:ring-teal-500",
				className,
			)}
			onSubmit={(e) => {
				e.preventDefault();
				onSubmit?.();
			}}
		>
			<IconSearch className="size-4 text-fg-muted" />
			<input
				type="search"
				value={value}
				disabled={disabled}
				placeholder={placeholder}
				onChange={(e) => onChange(e.target.value)}
				className="min-w-0 flex-1 bg-transparent text-sm text-fg outline-none placeholder:text-fg-muted max-sm:text-base"
				autoComplete="off"
				{...inputProps}
			/>
			{searching ? (
				<span className="text-xs text-fg-muted" aria-hidden>
					…
				</span>
			) : null}
		</form>
	);
}
